{
  "hero": {
    "title": "Servicii",
    "cta": "Ia legătura"
  },
  "services": [
    {
      "number": "01",
      "title": "Consultanță strategică UI/UX & Frontend",
      "description": "Pentru platforme complexe și companii orientate tehnologic. Cu 20 de ani de experiență, ofer leadership tehnic de nivel înalt pentru proiecte la scară largă.",
      "items": [
        {
          "title": "Audituri interfață",
          "description": "Identificarea punctelor de frecare în călătoriile complexe ale utilizatorilor."
        },
        {
          "title": "Sisteme de design",
          "description": "Construirea de biblioteci scalabile Figma-to-Code (React/Vue)."
        },
        {
          "title": "Arhitectură și performanță",
          "description": "Asigurarea că frontend-ul tău este la fel de rapid precum este frumos."
        }
      ]
    },
    {
      "number": "02",
      "title": "Inginerie brand holistică",
      "description": "De la primul schiță până la deploy-ul final. Nu cred în branding \"deconectat\". Construiesc identitatea ta vizuală și vitrina ta digitală ca un singur organism viu.",
      "items": [
        {
          "title": "Design identitate",
          "description": "Logo-uri, tipografie și brand books care se traduc în web."
        },
        {
          "title": "Dezvoltare web de înaltă performanță",
          "description": "Site-uri web codate personalizat, construite pentru conversie și viteză."
        },
        {
          "title": "Ecosisteme digitale",
          "description": "Asigurarea că brandul tău se simte la fel pe un smartphone precum pe un desktop."
        }
      ]
    },
    {
      "number": "03",
      "title": "Producție conținut cinematic",
      "description": "Legătura lipsă în afacerile moderne. Produc video și fotografie de înaltă calitate pe care majoritatea agențiilor se așteaptă să le furnizezi tu însuți. Proiectez site-ul tău în jurul conținutului pe care îl filmez.",
      "items": [
        {
          "title": "Povești de brand",
          "description": "Videoclipuri cinematice care umanizează compania ta."
        },
        {
          "title": "Videoclipuri demo produs și explicative",
          "description": "Făcând tehnologia complexă ușor de înțeles."
        },
        {
          "title": "Biblioteci de asset-uri",
          "description": "O bancă lunară de fotografii profesionale și videoclipuri de scurtă durată (Reels/TikTok) pentru a-ți menține social media-ul activ."
        }
      ]
    }
  ]
}
